// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__3NLPw","hidden":"Loader_hidden__2O8Px","loader":"Loader_loader__3XIeJ"};